import 'init/1-polyfills';
import { runWebBootstrap } from './runWebBootstrap';

window.alpha = true;

async function main(lifetime: DisposableStack) {
    const reactContainer = window.reactContainer;
    if (!reactContainer) {
        throw new Error('Web container startup entry did not initialize the React container');
    }

    const [
        { renderApp },
        { ReactRouter },
        { routes },
        { installBeforeUnloadGuard },
        { installWebNavigationEffects },
        { installTableErrorToasts },
    ] = await Promise.all([
        import('./App'),
        import('src/lib/router/react'),
        import('src/routes'),
        import('src/services/NavigationService/beforeUnload'),
        import('./installWebNavigationEffects'),
        import('src/features/table/installTableErrorToasts'),
    ]);

    const navigation = reactContainer.get('WebNavigationHost');
    lifetime.use(installBeforeUnloadGuard(navigation));
    // This is a container-scoped singleton. Resolving it starts its registration;
    // the entry owns that decision while the container owns its lifetime.
    reactContainer.get('WorkspaceNavigationGuardService');

    const router = new ReactRouter(routes, reactContainer, navigation);
    lifetime.use(router);
    await router.start(navigation.location.value);
    lifetime.use(installWebNavigationEffects(reactContainer, navigation));
    lifetime.use(installTableErrorToasts(reactContainer));
    renderApp(reactContainer, router);

    import.meta.hot?.dispose(() => lifetime[Symbol.dispose]());
}

void runWebBootstrap(main);
